const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  sort: "default",
  filter: "All",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    sortSelect: (state, action) => {
      state.sort = action.payload;
    },
    filterSelect: (state, action) => {
      state.filter = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { sortSelect, filterSelect } = filterSlice.actions;
